module.exports = __webpack_public_path__ + "img/03230.prt.7f49b328.jpg";